import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getCountries,
  createCampaign,
  annulCreateError,
  setFormState,
  resetCampaignStore,
  getCampaign,
  updateCampaign,
  resetCreateCampaignForm,
  patchCampaign,
  annulPatchError,
} from '../../reducers/create-campaign/duck';

import { getApps } from '../../reducers/create-app/duck';
import CreateCampaign from './CreateCampaign';

const mapStateToProps = ({
  campaignStore: {
    countries,
    countriesStatus,
    createCampaignStatus,
    createCampaignError,
    campaignId,
    formState,
    currentAppCampaigns,
    currentEditableCampaign,
    patchCampaignStatus,
    patchCampaignError,
  },
  oauthStore: {
    isAuthorized,
  },
  createAppStore: {
    getAppsStatus,
    getAppsError,
    apps,
  },
  userStore: {
    sidebarStatus,
  },
}) => ({
  countries,
  patchCampaignStatus,
  patchCampaignError,
  countriesStatus,
  getAppsStatus,
  getAppsError,
  campaignId,
  apps,
  createCampaignStatus,
  createCampaignError,
  formState,
  isAuthorized,
  currentAppCampaigns,
  currentEditableCampaign,
  sidebarStatus,
});

const mapDispatchToProps = {
  getCountries,
  getApps,
  createCampaign,
  annulCreateError,
  annulPatchError,
  setFormState,
  resetCampaignStore,
  getCampaign,
  updateCampaign,
  patchCampaign,
  resetCreateCampaignForm,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateCampaign));



// WEBPACK FOOTER //
// ./src/containers/CreateCampaign/index.js